import React from 'react';

function Modal({className = '', children, onClose, wrapClassName = '', ...props}) {
    const handleBackgroundClick = (e) => {
        if (e.target === e.currentTarget && onClose) {
            onClose();
        }
    };

    return (
        <div 
            className={`fixed top-[0] left-[0] z-[1000] bg-[rgba(0,0,0,.7)] h-screen w-screen flex items-center justify-center ${wrapClassName}`}
            onClick={handleBackgroundClick}
        >
            <div className={`content p-[40px] bg-white rounded-[6px] ${className}`}>{children}</div>
        </div>
    );
}

export default Modal;